/*
  RS FAQ (sections/rs-faq.liquid): slide open / closed for the <details> questions, "only one open
  at a time", opening the question or group in the URL (#<link name> or #faq-<n> / #<group>), and
  opening the question selected in the theme editor. Without this script the questions still open
  (no slide).
*/
if (!customElements.get('rs-faq')) {
  class RsFaq extends HTMLElement {
    connectedCallback() {
      this.one = this.dataset.one === 'true';
      this.items = Array.from(this.querySelectorAll('details.rs-faq__item'));
      this.items.forEach((item) => {
        item.querySelector('summary').addEventListener('click', (event) => {
          event.preventDefault();
          const isOpen = item.open && !item.classList.contains('is-closing');
          this.toggle(item, !isOpen);
        });
      });

      this.onHash = this.openFromHash.bind(this);
      window.addEventListener('hashchange', this.onHash);
      this.openFromHash();

      if (window.Shopify && window.Shopify.designMode) {
        this.onBlockSelect = (event) => {
          const item = event.target.closest && event.target.closest('details.rs-faq__item');
          if (item && this.contains(item)) this.toggle(item, true, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHash);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    duration() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
      const value = getComputedStyle(this).getPropertyValue('--rs-faq-speed');
      return parseFloat(value) || 0;
    }

    toggle(item, open, animate = true) {
      if (open && this.one) {
        this.items.forEach((other) => {
          if (other !== item && other.open) this.toggle(other, false, animate);
        });
      }

      const panel = item.querySelector('.rs-faq__a');
      const ms = animate ? this.duration() : 0;
      const from = item.open ? panel.getBoundingClientRect().height : 0;
      if (item.rsAnimation) {
        item.rsAnimation.onfinish = null;
        item.rsAnimation.cancel();
        item.rsAnimation = null;
      }

      if (open) {
        item.classList.remove('is-closing');
        item.open = true;
        if (!ms || !panel.animate) return;
        const to = panel.scrollHeight;
        item.rsAnimation = panel.animate([{ height: `${from}px` }, { height: `${to}px` }], {
          duration: ms,
          easing: 'ease-out',
        });
        item.rsAnimation.onfinish = () => {
          item.rsAnimation = null;
        };
      } else {
        if (!item.open) return;
        if (!ms || !panel.animate) {
          item.classList.remove('is-closing');
          item.open = false;
          return;
        }
        item.classList.add('is-closing');
        item.rsAnimation = panel.animate([{ height: `${from}px` }, { height: '0px' }], {
          duration: ms,
          easing: 'ease-out',
        });
        item.rsAnimation.onfinish = () => {
          item.rsAnimation = null;
          item.classList.remove('is-closing');
          item.open = false;
        };
      }
    }

    openFromHash() {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || !this.contains(target)) return;
      let item = target.matches('details.rs-faq__item') ? target : null;
      if (!item && target.classList.contains('rs-faq__group')) {
        // A group: open its first question.
        let next = target.nextElementSibling;
        while (next && !next.matches('details.rs-faq__item, .rs-faq__group')) next = next.nextElementSibling;
        if (next && next.matches('details.rs-faq__item')) item = next;
      }
      if (item) this.toggle(item, true, false);
      target.scrollIntoView({ block: 'start' });
    }
  }

  customElements.define('rs-faq', RsFaq);
}
